import { safeRedirect } from '@jurnee/common/src/browser/safeRedirect';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { completeMagicLink, completeToken } from 'api/auth';
import { RootState } from '..';

function completeAuth(token: string) {
  localStorage.setItem('token', token);

  const searchParams = new URLSearchParams(window.location.search);

  window.location.href = safeRedirect(searchParams.get('redirect'));
}

export const login = createAsyncThunk<void, string, { state: RootState }>('AUTH_LOGIN', async (token, thunkAPI) => {
  try {
    const data = await completeMagicLink(token);

    completeAuth(data.token);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    return thunkAPI.rejectWithValue({ error: message });
  }
});

export const connectAs = createAsyncThunk<void, string, { state: RootState }>('AUTH_CONNECT_AS', async (token, thunkAPI) => {
  try {
    const data = await completeToken({ token });

    completeAuth(data.token);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    return thunkAPI.rejectWithValue({ error: message });
  }
});